/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(window).load(function(){
	hoverProduct();
});
$(document).ready(function(){
 $(".image-container .slider").val("50");
 hoverProduct();
  $(".slickClass").slick();
   $(".collectionContent.is-active").fadeIn();
  $(".is-active .carouselSlider").slick();
  
  if(isTouchDevice()){
  	$(".custom-featured-collection .innerPerProductCont .bottomSection").css("display","block");
  }
  var productThumbnailsLength = $(".Product__SlideshowNavScroller .Product__SlideshowNavImage").length;
  console.log(productThumbnailsLength);
  if(productThumbnailsLength > 5 ){
    $(".arrow-prev").removeClass("d-none");
    $(".arrow-next").removeClass("d-none");
    $(".Product__SlideshowNavScroller").slick({
      dots: false,
      slidesToShow: 5,
      centerPadding: "10px",
      draggable: false,
      infinite: true,
      pauseOnHover: false,
      swipe: false,
      touchMove: false,
      vertical:true,
      speed: 1000,
      autoplaySpeed: 2000,
      useTransform: true,
      cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
      adaptiveHeight: true,
      prevArrow: $('.arrow-prev'),
        nextArrow: $('.arrow-next'),
    });
  }
  
  $(".customReview").slick({
      slidesToShow: 1,
      centerPadding: "10px",
      draggable: false,
      infinite: true,
    dots: false,
    arrow:false,
    touchMove: true,
    	autoplay: true,
  		autoplaySpeed: 2000
      
    });
});

/*let $carousel = $('.Carousel').flickity({});
$(window).on("load",function() {
  $carousel.flickity('resize');
});*/
$(".cc_Faq__QuestionWrapper .cc_Faq__Question").click(function(){
  $(".cc_Faq__AnswerWrapperMain").addClass("d-none");
  if($(this).parents(".cc_Faq__ItemWrapper").find(".cc_Faq__AnswerWrapperMain").hasClass("d-none")){
  	$(this).parents(".cc_Faq__ItemWrapper").find(".cc_Faq__AnswerWrapperMain").removeClass("d-none");
  }else{
  	$(".cc_Faq__AnswerWrapperMain").addClass("d-none");
  }
	
});
$(".CollectionItem__ImageWrapper").hover(
  function () {
    $(this).find(".placeholderSection").attr("style","opacity:0;transition:opacity 1s;");
  },
  function () {
    $(this).find(".placeholderSection").attr("style","opacity:.50;transition:opacity 1s;");  
  }
	
);
$(".custom-featured-collection .collectionContent .perProductCont").mouseenter(function () {
    $(this).addClass("active");
  }
  	
);
$(".custom-featured-collection .collectionContent .perProductCont").mouseleave(function () {
    $(this).removeClass("active");
  }	
);
$(window).scroll(function(){
    navigationScrol();
});
function hoverProduct(){
	$(".perProductCont").mouseenter(function () {
        $(this).addClass("active");
      }

    );
    $(".perProductCont").mouseleave(function () {
        $(this).removeClass("active");
      }	
    );
}
function navigationScrol(){
	var scrollTop = $(document).scrollTop();
  if(scrollTop > 100){
  	$("#section-header").addClass("scrolledHeader");
  }else{
  	$("#section-header").removeClass("scrolledHeader");
  }
}

$(".tab-button").click(function(){
  
  //$( '.collectionContent' ).not( ".is-active").find(".carouselSlider").slick('unslick');
  var activeID = $(this).attr("id");
  $(".tab-button").removeClass("is-active");
  $(this).addClass("is-active");
 
   
  
  $(".collectionContent").removeClass("is-active");
  $(".collectionContent").addClass("not-active");
  $(".collectionContent").fadeOut();
  $(this).parents(".tabbed-content").find("#" + activeID +"_text").addClass("is-active");
  $(this).parents(".tabbed-content").find("#" + activeID +"_text").removeClass("not-active");
  $(this).parents(".tabbed-content").find("#" + activeID +"_text").fadeIn();
  
  if($(this).parents(".tabbed-content").find("#" + activeID +"_text .carouselSlider").hasClass("slick-initialized")){
  
  }else{
    $(this).parents(".tabbed-content").find("#" + activeID +"_text .carouselSlider").slick();
  }
  $(".not-active .carouselSlider").slick('unslick');
   
 
});

function isTouchDevice(){
    return typeof window.ontouchstart !== 'undefined';
}
$(".slider").on("input change", (e)=>{
  const sliderPos = e.target.value;
  console.log(e.target.id);
  // Update the width of the foreground image
  $("#" + e.target.id).parent().find('.foreground-img').css('width', `${sliderPos}%`)
  // Update the position of the slider button
  $("#" + e.target.id).parent().find('.slider-button').css('left', `calc(${sliderPos}% - 18px)`)
});

$(".triggerBoldMembershipbtn").click(function(){
	$(".memberships_button").trigger("click");
});